'use strict';

import jQuery from 'jquery';
import FontFaceObserver from 'fontfaceobserver';
import { MediaQuery, DropdownMenu, Tabs, SmoothScroll, Toggler } from 'foundation-sites';
import 'owl.carousel';
import 'slick-carousel';
import fitvids from 'fitvids';

($ => {
  initComponents();

  /**
   * Window load event listener
   *
   */
  $(window).on('load', () => {
    $('.js-loading__inner').fadeOut('slow', function() {
      var timer = setInterval(function() {

        $('.js-loading').fadeOut(300);

        clearInterval(timer);
      }, 100);
    });
  });

  /**
   * Initialize components.
   */
  function initComponents() {
    initHeader();
    fonts();
    searchForm();
    carousel('.js-clients-carousel', {
      items: 7,
      loop: true,
      dots: false,
      autoplay: true,
      autoplayTimeout: 18000,
      autoplaySpeed: 1200,
      autoplayHoverPause: false,
      nav: true,
      responsive: {
        0: {
          items: 3
        },
        640: {
          items: 5
        },
        1024: {
          items: 7
        }
      }
    });
    carousel2('.js-slider', {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      adaptiveHeight: true,
      autoplay: false,
      autoplaySpeed: 9000,
      asNavFor: '.js-slider-nav'
    });
    carousel2('.js-slider-nav', {
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.js-slider',
      arrows: false,
      dots: false,
      centerMode: true,
      focusOnSelect: true
    });
    initCheckboxes();
    initFileUpload();
    // initSmoothScrolling();
    fitVideoToContainer();
    contentReadMore();
    loadMore();
    initZF();
    console.log('Developed by: Nordanne Isahac https://www.denisahac.xyz');
  }
  
  /**
   * Header
   */
  function initHeader() {
    var isBackground = false;
    var $header = $('#container > header');
    var scrollTop = $(window).scrollTop();
    
    toggleBackground();

    $(window).scroll(() => {
      scrollTop = $(window).scrollTop();
      toggleBackground();
    });

    function toggleBackground() {
      if(scrollTop > 100 && !isBackground) {
        $header.addClass('scrolled');  
        isBackground = true;
      } else if(scrollTop <= 100 && isBackground) {
        $header.removeClass('scrolled'); 
        isBackground = false;
      }
    }

  }

  /**
   * Initialize Zurb Foundation.
   */
  function initZF() {
    if($().foundation) {
      $(document).foundation();

      var $scrolls = $('.js-smooth-scroll');

      if($scrolls.length) {
        new SmoothScroll($scrolls, {
          threshold: 0,
          offset: getHeaderHeight()
        });
      }
    }
  }

  /**
   * Font loader
   */
  function fonts() {
    if(FontFaceObserver) {
      const fontSyncopate = new FontFaceObserver('Syncopate');
      const fontOpenSans = new FontFaceObserver('Open Sans');

      $(document.body).addClass('font');

      fontSyncopate.load(null, 10000).then(() => {
        $(document.body).addClass('font--syncopate');
      });

      fontOpenSans.load(null, 10000).then(() => {
        $(document.body).addClass('font--opensans')
      });
    }
  }

  /**
   * Toggle search form.
   */
  function searchForm() {
    const $search = $('.js-search');
    const $close = $('.js-close');
    const $searchForm = $('#search-form-wrapper');
    
    $search.click(e => {
      e.preventDefault();

      $searchForm.addClass('visible');   
      $searchForm.find('input[type="text"]').focus();
    });

    $close.click(e => {
      e.preventDefault();

      $searchForm.removeClass('visible');
    });

  }

  /**
   * Checkbox customization.
   */
  function initCheckboxes() {
    var $checkboxes = $('[type="checkbox"]');

    $checkboxes.each((i, e) => {
      var $checkbox = $(e);
      
      toggleCheckbox($checkbox);

      $checkbox.change(function() {
        toggleCheckbox(this);
      });
    });

    /**
     * Toggle checkbox
     */
    function toggleCheckbox(el) {
      if($(el).is(':checked')) {
        $(el).parent('label').addClass('checked');
      } else {
        $(el).parent('label').removeClass('checked');
      }
    }
  }

  /**
   * File upload input.
   */
  function initFileUpload() {
    $('[type="file"]').each( function() {
      var $input	 = $( this ),
        $file = $input.closest('.file'),
        $label	 = $input.find('label'),
        labelVal = $label.html();

      $input.on( 'change', function( e ) {
        var fileName = '';

        if( this.files && this.files.length > 1 )
          fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
        else if( e.target.value )
          fileName = e.target.value.split( '\\' ).pop();

        if( fileName )
          $file.find('.file__name').html( fileName );
        else
          $file.find('.file__name').html( labelVal );
      });

      // Firefox bug fix
      $input
      .on( 'focus', function(){ $input.addClass( 'has-focus' ); })
      .on( 'blur', function(){ $input.removeClass( 'has-focus' ); });
    });
  }

  /**
   * Smooth scrolling.
   */
  function initSmoothScrolling() {
    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
          && 
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top - getHeaderHeight()
            }, 1000, function() {
              // Callback after animation
            });
          }
        }
      });
  }

  /**
   * Get the height of the main header.
   *
   * @return int The height of the header in pixels.
   */
  function getHeaderHeight() {
    return $('#container > header').innerHeight(); 
  }

  /**
   * Generate carousel
   * 
   * @param {string} elem The target element
   * @param {object} options The carousel options
   */
  function carousel(elem, options) {
    if($().owlCarousel) {
      $(elem).owlCarousel(options);
    }
  }

  /**
   * Carousel implementation using Slick.
   *
   * @param {string} elem The target element
   * @param {object} options The carousel options
   */
  function carousel2(elem, options) {
    if($().slick) {
      $(elem).slick(options);
    }
  }

  /**
   * Fit video
   */
  function fitVideoToContainer() {
    fitvids('.js-video-wrapper');
  }
  
  /**
	 * Content read more.
	 */
	function contentReadMore() {
		$('.js-content').each((i, e) => {	
      let $e = $(e);
      let height = $e.data('height');

			if($e.innerHeight() > height) {
				$e.addClass('overflowed');
        $e.css('max-height', height + 'px');
			}
		});

		$('.js-readmore').click(function(e) {
			e.preventDefault();
      let $content = $(this).parent().parent('.js-content');

      $content.removeClass('overflowed');
      $content.removeAttr('style');
		});
	}

  /**
   * Load more artists.
   */
  function loadMore() {
    let $content = $('.js-artists');
    let $loadmore = $('.js-loadmore');
    var page = $loadmore.data('page');

    $loadmore.click(function(e) {
      e.preventDefault();

      if($(this).hasClass('disabled')) return;

      page++;

      let payload = {
        action: 'jabu_events_load_more_artists',
        category: $(this).data('category'),
        type: $(this).data('type'),
        p: page
      };

      $.ajax({
        type: 'GET',
        url: jabu_events.ajax_url,
        data: payload,
        success: function(res) {
          $content.append(res);
        },
        error: function(res) {
          $loadmore.addClass('disabled');
        }
      });

    });
  }

  /**
   * Shortland for console.log
   *
   * @param {string|object} message The message to log
   */
  function log(message) {
    console.log(message);
  }
})(jQuery);
